import React, { useState, useRef, useEffect } from "react";
import PersonIcon from "@mui/icons-material/Person";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Badge from "@mui/material/Badge";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import PeopleIcon from "@mui/icons-material/People";
import { jwtDecode } from "jwt-decode";
import { useLoading } from "../../../../context/LoadingContext";
import { getParameterFromManager } from "../../../../services/Utils";
import MessageIcon from "@mui/icons-material/Message";
import { fetchData } from "../../../Requirement/services/RequirementServices";
import { NotificationCenter } from "../../../../components/common/notifications";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

// Import the HelpModal component
import HelpModal from "../../../../services/HelpModalComponent";

const Header = ({ clientmenu, module }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeUser, setActiveUser] = useState("");
  const [modeUser, setModeUser] = useState(module);
  const dropdownRef = useRef(null);

  const [isNotificationDropdownVisible, setIsNotificationDropdownVisible] =
    useState(false);
  const [isProfileDropdownVisible, setIsProfileDropdownVisible] =
    useState(false);
  const [isHelpDropdownVisible, setIsHelpDropdownVisible] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  const [userMessageCount, setUserMessageCount] = useState(0);
  const { setLoading } = useLoading();
  const [INRToUsd, setINRToUSD] = useState(0.012);

  const [userKybInfo, setUserKybInfo] = useState(null);
  const [isKybLoading, setIsKybLoading] = useState(true);

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
  });

  useEffect(() => {
    if (location.pathname.startsWith("/global-partner-buyer")) {
      setModeUser("gpbuyer");
    } else if (location.pathname.startsWith("/global-partner")) {
      setModeUser("gp");
    }
  }, [location.pathname]);

  const Signout = async () => {
    setLoading(true);
    try {
      localStorage.clear();
      navigate("/login/global-partner");
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];

        if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
          await Auth.signOut();
          navigate("/global-partner");
        } else {
          setActiveUser(user.attributes.email);
        }

        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        setINRToUSD(parseFloat(inrToUsdVal));
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
  }, [navigate]);

  const handleSubmit = () => {
    setModal({
      show: true,
      type: "warning",
      message: "Are you sure you want to log Out?",
      isConfirm: true,
      onConfirm: confirmLogout,
      onCancel: () => setModal((prev) => ({ ...prev, show: false })),
    });
  };

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const confirmLogout = () => {
    setModal((prev) => ({ ...prev, show: false }));
    setModal({
      show: true,
      type: "success",
      title: "Success!",
      message: "Signed out successfully.",
      autoClose: false,
      nextAction: () => Signout(),
    });
  };

  const handleLayoutModeChange = ({ mode }) => {
    setModeUser(mode);
    if (mode === "gpbuyer") navigate("/global-partner-buyer");
    else navigate("/global-partner");
  };

  const redirectToMessage = () => navigate("/global-partner/messaging");

  useEffect(() => {
    const checkUserMessageCount = async () => {
      try {
        if (!activeUser) return;
        const msgResponse = await fetchData({
          target: "listMessages",
          userOrder: "CreatedAt",
          orderDirection: "ASC",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: { ReceiverUserID: activeUser, IsRead: 0 },
        });
        setUserMessageCount(msgResponse.total || 0);
      } catch {
        setUserMessageCount(0);
      }
    };
    const checkUserKYB = async () => {
      setIsKybLoading(true);
      try {
        if (!activeUser) return;
        const userKYBResponse = await fetchData({
          target: "listUserKYB",
          userOrder: "UserKybID",
          orderDirection: "ASC",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { EmailID: activeUser },
        });
        if (userKYBResponse.items && userKYBResponse.items.length > 0) {
          setUserKybInfo(userKYBResponse.items[0] || null);
        } else {
          setUserKybInfo(null);
        }
      } catch (error) {
        console.error("Error fetching KYB info:", error);
        setUserKybInfo(null);
      } finally {
        setIsKybLoading(false);
      }
    };

    checkUserMessageCount();
    if (activeUser) {
      checkUserKYB();
    }
  }, [activeUser]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsNotificationDropdownVisible(false);
        setIsProfileDropdownVisible(false);
        setIsHelpDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ Fix: close dropdown when Help modal opens
  useEffect(() => {
    if (isHelpModalVisible) setIsHelpDropdownVisible(false);
  }, [isHelpModalVisible]);

  const menuItems = [
    {
      icon: <MenuBookOutlinedIcon style={{ color: "#4472C4" }} />,
      title: "Help",
      subtitle: "Get help from our self-serve repository",
      link: "#",
    },
    {
      icon: <ChatBubbleOutlineIcon style={{ color: "#F4B183" }} />,
      title: "Chat with us",
      subtitle: "24/7 support for platform and data query",
      link: "/global-partner/messaging",
    },
    {
      icon: <EmailOutlinedIcon style={{ color: "#5B9BD5" }} />,
      title: "Email",
      subtitle: "support@agropreneurs.in",
      link: "/global-partner/support",
    },
    {
      icon: <WhatsAppIcon style={{ color: "#70AD47" }} />,
      title: "WhatsApp",
      subtitle: "+91-xxxxxxxxxx",
      link: "https://wa.me/91111111111",
    },
  ];

  const goToProfile = () => {
    navigate("/global-partner/profile");
  };

  //  Updated openHelpModal
  const openHelpModal = () => {
    setIsHelpDropdownVisible(false);
    setTimeout(() => setIsHelpModalVisible(true), 0);
  };

  return (
    <div className="header" ref={dropdownRef}>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />

      <header>
        <div className="header-cus">
          <img src="/images/logo.png" alt="Logo" className="logo" />
        </div>

        <div className="diplay-flex-css">
          {/* Mode Switch Buttons */}
          <div className="breadcumbs">
            <div className="button-group" style={{ position: "relative" }}>
              <div
                onMouseEnter={() => setHoveredButton("trade")}
                onMouseLeave={() => setHoveredButton(null)}
                style={{ position: "relative", display: "inline-block" }}
              >
                <button
                  className={`submit-btn-more1 ${
                    modeUser === "gp" ? "active" : ""
                  }`}
                  onClick={() => handleLayoutModeChange({ mode: "gp" })}
                >
                  My Trade
                </button>
                {hoveredButton === "trade" && (
                  <div className="custom-tooltip">Switch to My Trade</div>
                )}
              </div>

              <div
                onMouseEnter={() => setHoveredButton("buyer")}
                onMouseLeave={() => setHoveredButton(null)}
                style={{ position: "relative", display: "inline-block" }}
              >
                <button
                  className={`submit-btn-more1 ${
                    modeUser === "gpbuyer" ? "active" : ""
                  }`}
                  onClick={() => handleLayoutModeChange({ mode: "gpbuyer" })}
                >
                  Buyer Trade
                </button>
                {hoveredButton === "buyer" && (
                  <div className="custom-tooltip">Switch to Buyer Trade</div>
                )}
              </div>
            </div>
          </div>

          {/* KYB Info */}
          {isKybLoading ? null : userKybInfo === null ||
            !userKybInfo?.Status ||
            userKybInfo.Status === "" ||
            userKybInfo.Status === "Pending" ? (
            <div className="breadcrumbs2">
              <span
                className="kyb-link"
                style={{ cursor: "pointer", textDecoration: "none" }}
              >
                {userKybInfo === null ||
                !userKybInfo?.Status ||
                userKybInfo.Status === "" ? (
                  <>
                    Please complete your KYB verification to proceed.{" "}
                    <button
                      className="export-btn"
                      onClick={() => navigate("/global-partner/setting")}
                    >
                      Click Here
                    </button>
                  </>
                ) : (
                  <>
                    KYB is under review.{" "}
                    <button
                      className="export-btn"
                      onClick={() => navigate("/global-partner/setting")}
                    >
                      View Here
                    </button>
                  </>
                )}
              </span>
            </div>
          ) : userKybInfo.Status !== "Approved" ? (
            <div className="breadcrumbs2">
              <span
                className="kyb-link"
                style={{ cursor: "pointer", textDecoration: "none" }}
              >
                KYB is under review.{" "}
                <button
                  className="export-btn"
                  onClick={() => navigate("/global-partner/setting")}
                >
                  View Here
                </button>
              </span>
            </div>
          ) : null}

          {/* Right Icons */}
          <nav>
            <ul>
              <li className="profile-menu">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Badge
                    badgeContent={
                      userMessageCount > 0 ? userMessageCount : null
                    }
                    color="error"
                    onClick={redirectToMessage}
                    style={{ marginRight: "15px", cursor: "pointer" }}
                  >
                    <MessageIcon
                      style={{ width: "20px", color: "#4c4949da" }}
                    />
                  </Badge>

                  <div style={{ marginRight: "15px" }}>
                    <NotificationCenter size="medium" />
                  </div>

                  {/* Help Dropdown */}
                  <div
                    style={{ position: "relative", marginRight: "15px" }}
                    onClick={() => setIsHelpDropdownVisible((prev) => !prev)}
                  >
                    <HelpOutlineIcon
                      style={{
                        width: "22px",
                        color: "#4c4949da",
                        cursor: "pointer",
                      }}
                    />
                    {isHelpDropdownVisible && (
                      <div
                        style={{
                          position: "absolute",
                          top: "35px",
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
                          width: "280px",
                          zIndex: 9999,
                          padding: "6px 0",
                          borderRadius: "5px",
                        }}
                      >
                        {menuItems.map((item, index) => {
                          const isExternal =
                            item.link?.startsWith("http") ||
                            item.link?.startsWith("mailto");

                          return isExternal ? (
                            // 🌐 External link: open normally or in new tab
                            <a
                              key={index}
                              href={item.link}
                              target={
                                item.title === "WhatsApp" ? "_blank" : "_self"
                              }
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "#333",
                                display: "flex",
                                alignItems: "flex-start",
                                padding: "10px 15px",
                                gap: "10px",
                                transition: "background 0.2s",
                                fontWeight: 400,
                                borderRadius: "6px",
                              }}
                              onMouseOver={(e) =>
                                (e.currentTarget.style.background = "#f9f9f9")
                              }
                              onMouseOut={(e) =>
                                (e.currentTarget.style.background =
                                  "transparent")
                              }
                              onClick={() => setIsHelpDropdownVisible(false)}
                            >
                              <div>{item.icon}</div>
                              <div>
                                <div
                                  style={{ fontWeight: 600, fontSize: "14px" }}
                                >
                                  {item.title}
                                </div>
                                {item.subtitle && (
                                  <div
                                    style={{ fontSize: "12px", color: "#777" }}
                                  >
                                    {item.subtitle}
                                  </div>
                                )}
                              </div>
                            </a>
                          ) : (
                            // 🧭 Internal link using React Router
                            <Link
                              key={index}
                              to={item.link || "#"}
                              style={{
                                textDecoration: "none",
                                color: "#333",
                                display: "flex",
                                alignItems: "flex-start",
                                padding: "10px 15px",
                                gap: "10px",
                                transition: "background 0.2s",
                                fontWeight: 400,
                                borderRadius: "6px",
                              }}
                              onMouseOver={(e) =>
                                (e.currentTarget.style.background = "#f9f9f9")
                              }
                              onMouseOut={(e) =>
                                (e.currentTarget.style.background =
                                  "transparent")
                              }
                              onClick={(e) => {
                                setIsHelpDropdownVisible(false);
                                if (item.title === "Help") {
                                  e.preventDefault();
                                  openHelpModal();
                                }
                              }}
                            >
                              <div>{item.icon}</div>
                              <div>
                                <div
                                  style={{ fontWeight: 600, fontSize: "14px" }}
                                >
                                  {item.title}
                                </div>
                                {item.subtitle && (
                                  <div
                                    style={{ fontSize: "12px", color: "#777" }}
                                  >
                                    {item.subtitle}
                                  </div>
                                )}
                              </div>
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  {/* Profile */}
                  <div
                    onClick={() => setIsProfileDropdownVisible((prev) => !prev)}
                    style={{
                      marginLeft: "10px",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <PersonIcon style={{ width: "20px", color: "#4c4949da" }} />
                    {activeUser}
                    {isProfileDropdownVisible ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </div>

                  {isProfileDropdownVisible && (
                    <div className="profile-dropdown">
                      <div className="dropdown-content">
                        <button onClick={goToProfile} className="dropdown-item">
                          <PeopleIcon /> Profile
                        </button>
                        <div className="border-1"></div>
                        <button
                          onClick={handleSubmit}
                          className="dropdown-item"
                        >
                          <ExitToAppIcon /> Sign Out
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Help Modal */}
      {isHelpModalVisible && (
        <HelpModal
          onClose={() => setIsHelpModalVisible(false)}
          userType="globalpartner"
        />
      )}

      {/* Inline CSS */}
      <style>
        {`
        .submit-btn-more1 {
          background-color: #f0f0f0;
          color: #333;
          padding: 8px 16px;
          border: none;
          border-radius: 22px;
          cursor: pointer;
          margin: 0 5px;
          position: relative;
        }

        .submit-btn-more1.active {
          background-color: #de6b14;
          color: #fff;
        }

        .custom-tooltip {
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          background-color: #de6b14;
          color: white;
          padding: 6px 10px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 500;
          white-space: nowrap;
          z-index: 9999;
          box-shadow: 0 4px 10px rgba(0,0,0,0.15);
        }

        .custom-tooltip::after {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          border-width: 6px;
          border-style: solid;
          border-color: #de6b14 transparent transparent transparent;
        }
      `}
      </style>
    </div>
  );
};

export default Header;
